module.exports = __webpack_public_path__ + "img/face20.9c095f45.jpg";